'use client'

import { useCallback, useState } from 'react'

import { AlertBox, AlertBoxType, Button, Icon } from '@graftcode/design-system'

import { GraftabilityIssueList } from '@/core/components/GraftabilityIssueList'
import { GraftFilterWizard } from '@/core/components/GraftFilterWizard'
import type { LibraryData } from '@/core/types/library.type'
import type { LibraryGraftabilityReport } from '@/core/utils/graftability'

import styles from './GraftabilityWarningTabContent.module.scss'

interface GraftabilityWarningTabContentProps {
  libraryData?: LibraryData
  report: LibraryGraftabilityReport
}

export function GraftabilityWarningTabContent({ libraryData, report }: GraftabilityWarningTabContentProps) {
  const [wizardOpen, setWizardOpen] = useState(false)
  const openWizard = useCallback(() => setWizardOpen(true), [])

  return (
    <div className={styles.root}>
      <AlertBox
        type={AlertBoxType.Warning}
        title="Graft download requires filters"
        description="To enable downloading grafts, you must apply filters. This module exposes complex types in method parameters or return values that cannot be included in consumer Grafts."
        showCloseButton={false}
      >
        <div className={styles.actions}>
          <Button
            text="Create and configure filters"
            icon={Icon.FilterRegular}
            variant="outlined"
            size="s"
            onClick={openWizard}
          />
        </div>
      </AlertBox>

      {report.issues.length > 0 && (
        <section className={styles.issues} aria-labelledby="graftability-warning-issues">
          <h3 id="graftability-warning-issues" className={styles.issuesTitle}>
            Analyzer comments
          </h3>
          <GraftabilityIssueList issues={report.issues} className={styles.issueList} />
        </section>
      )}

      <GraftFilterWizard open={wizardOpen} libraryData={libraryData} onOpenChange={setWizardOpen} />
    </div>
  )
}
